var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 389.95 247.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5455eb;\n      }\n\n      .cls-2 {\n        fill: #7651fd;\n      }\n\n      .cls-3 {\n        fill: #054da5;\n      }\n\n      .cls-4 {\n        fill: #032e71;\n      }\n\n      .cls-5 {\n        fill: #6e52f9;\n      }\n\n      .cls-6 {\n        fill: #043e8c;\n      }\n\n      .cls-7 {\n        fill: #043a86;\n      }\n\n      .cls-8 {\n        fill: #065ec2;\n      }\n\n      .cls-9 {\n        fill: #195ccc;\n      }\n\n      .cls-10 {\n        fill: #3059d8;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-12 {\n        fill: #0554b2;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-14 {\n        fill: #0c5dc5;\n      }\n\n      .cls-15 {\n        fill: #0f5dc7;\n      }\n\n      .cls-16 {\n        fill: #1f5bcf;\n      }\n\n      .cls-17 {\n        fill: #6353f3;\n      }\n\n      .cls-18 {\n        fill: #065cbf;\n      }\n\n      .cls-19 {\n        fill: #3858dc;\n      }\n\n      .cls-20 {\n        fill: #043985;\n      }\n\n      .cls-21 {\n        fill: #0555b3;\n      }\n\n      .cls-22 {\n        fill: #295ad5;\n      }\n\n      .cls-23 {\n        fill: #6953f6;\n      }\n\n      .cls-24 {\n        fill: #0656b4;\n      }\n\n      .cls-25 {\n        fill: #1a5ccc;\n      }\n\n      .cls-26 {\n        fill: #032a6b;\n      }\n\n      .cls-27 {\n        fill: #043279;\n      }\n\n      .cls-28 {\n        fill: #4657e4;\n      }\n\n      .cls-29 {\n        fill: #4557e3;\n      }\n\n      .cls-30 {\n        fill: #0551ad;\n      }\n\n      .cls-31 {\n        fill: #2d59d7;\n      }\n\n      .cls-32 {\n        fill: #4257e2;\n      }\n\n      .cls-33 {\n        fill: #3e58df;\n      }\n\n      .cls-34 {\n        fill: #5854ed;\n      }\n\n      .cls-35 {\n        fill: #4e56e8;\n      }\n\n      .cls-36 {\n        fill: #5755ed;\n      }\n\n      .cls-37 {\n        fill: #054aa0;\n      }\n\n      .cls-38 {\n        fill: #4357e2;\n      }\n\n      .cls-39 {\n        fill: #043781;\n      }\n\n      .cls-40 {\n        fill: #0b5dc5;\n      }\n\n      .cls-41 {\n        fill: #3f57e0;\n      }\n\n      .cls-42 {\n        fill: #175ccb;\n      }\n\n      .cls-43 {\n        fill: #2a5ad5;\n      }\n\n      .cls-44 {\n        fill: #6b52f7;\n      }\n\n      .cls-45 {\n        fill: #0554b1;\n      }\n\n      .cls-46 {\n        fill: #04357d;\n      }\n\n      .cls-47 {\n        fill: #6c52f8;\n      }\n\n      .cls-48 {\n        fill: #6054f1;\n      }\n\n      .cls-49 {\n        fill: #7351fc;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-51 {\n        fill: #065abb;\n      }\n\n      .cls-52 {\n        fill: #032d6f;\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-54 {\n        fill: #5c54ef;\n      }\n\n      .cls-55 {\n        fill: #043d8a;\n      }\n\n      .cls-56 {\n        fill: #5155ea;\n      }\n\n      .cls-57 {\n        fill: #6f52f9;\n      }\n\n      .cls-58 {\n        opacity: .2;\n      }\n\n      .cls-59 {\n        fill: #054ca3;\n      }\n\n      .cls-60 {\n        fill: #032c6e;\n      }\n\n      .cls-61 {\n        fill: #032b6d;\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-63 {\n        fill: #043d8b;\n      }\n\n      .cls-64 {\n        fill: #04337b;\n      }\n\n      .cls-65 {\n        fill: #0656b5;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-67 {\n        fill: #04357e;\n      }\n\n      .cls-68 {\n        fill: #235bd1;\n      }\n\n      .cls-69 {\n        fill: #04337a;\n      }\n\n      .cls-70 {\n        fill: #265ad3;\n      }\n\n      .cls-71 {\n        fill: #3658db;\n      }\n\n      .cls-72 {\n        fill: #043e8d;\n      }\n\n      .cls-73 {\n        fill: #125dc9;\n      }\n\n      .cls-74 {\n        fill: #0550aa;\n      }\n\n      .cls-75 {\n        fill: #054fa9;\n      }\n\n      .cls-76 {\n        fill: #7451fc;\n      }\n\n      .cls-77 {\n        fill: #044191;\n      }\n\n      .cls-78 {\n        fill: #032b6c;\n      }\n\n      .cls-79 {\n        fill: #4756e4;\n      }\n\n      .cls-80 {\n        fill: #43299a;\n      }\n\n      .cls-81 {\n        fill: #043984;\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-83 {\n        fill: #032e72;\n      }\n\n      .cls-84 {\n        fill: #065abc;\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-87 {\n        fill: #3c58de;\n      }\n\n      .cls-88 {\n        fill: #3958dd;\n      }\n\n      .cls-89 {\n        fill: #04408f;\n      }\n\n      .cls-90 {\n        fill: #5954ee;\n      }\n\n      .cls-91 {\n        fill: #5b54ef;\n      }\n\n      .cls-92 {\n        fill: #054ca4;\n      }\n\n      .cls-93 {\n        fill: #0550ab;\n      }\n\n      .cls-94 {\n        fill: #4157e1;\n      }\n\n      .cls-95 {\n        fill: #165cca;\n      }\n\n      .cls-96 {\n        fill: #043882;\n      }\n\n      .cls-97 {\n        fill: #054fa8;\n      }\n\n      .cls-98 {\n        fill: #0a5ec4;\n      }\n\n      .cls-99 {\n        fill: #065dc0;\n      }\n\n      .cls-100 {\n        fill: #5555ec;\n      }\n\n      .cls-101 {\n        fill: #0553b0;\n      }\n\n      .cls-102 {\n        fill: #225bd1;\n      }\n\n      .cls-103 {\n        fill: #085ec3;\n      }\n\n      .cls-104 {\n        fill: #054699;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-106 {\n        fill: #1b5ccd;\n      }\n\n      .cls-107 {\n        fill: #6853f6;\n      }\n\n      .cls-108 {\n        fill: #2c5ad6;\n      }\n\n      .cls-109 {\n        fill: #2f59d8;\n      }\n\n      .cls-110 {\n        fill: #155cca;\n      }\n\n      .cls-111 {\n        fill: #04347c;\n      }\n\n      .cls-112 {\n        fill: #054497;\n      }\n\n      .cls-113 {\n        fill: #05489d;\n      }\n\n      .cls-114 {\n        fill: #4a56e6;\n      }\n\n      .cls-115 {\n        fill: #4b56e6;\n      }\n\n      .cls-116 {\n        fill: #04367f;\n      }\n\n      .cls-117 {\n        fill: #0551ac;\n      }\n\n      .cls-118 {\n        fill: #033176;\n      }\n\n      .cls-119 {\n        fill: #095ec4;\n      }\n\n      .cls-120 {\n        fill: #05469a;\n      }\n\n      .cls-121 {\n        fill: #03ede9;\n      }\n\n      .cls-122 {\n        fill: #05479b;\n      }\n\n      .cls-123 {\n        fill: #5055e9;\n      }\n\n      .cls-124 {\n        fill: #255ad2;\n      }\n\n      .cls-125 {\n        fill: #043b87;\n      }\n\n      .cls-126 {\n        fill: #0553af;\n      }\n\n      .cls-127 {\n        fill: #205bd0;\n      }\n\n      .cls-128 {\n        fill: #7551fd;\n      }\n\n      .cls-129 {\n        fill: #043c89;\n      }\n\n      .cls-130 {\n        fill: #3d58df;\n      }\n\n      .cls-131 {\n        fill: #185ccb;\n      }\n\n      .cls-132 {\n        fill: #105dc7;\n      }\n\n      .cls-133 {\n        fill: #3159d9;\n      }\n\n      .cls-134 {\n        fill: #fdab07;\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-136 {\n        fill: #245bd2;\n      }\n\n      .cls-137 {\n        fill: #3459da;\n      }\n\n      .cls-138 {\n        fill: #043883;\n      }\n\n      .cls-139 {\n        fill: #0657b7;\n      }\n\n      .cls-140 {\n        fill: #5d54f0;\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-142 {\n        fill: #145cc9;\n      }\n\n      .cls-143 {\n        fill: #5e54f0;\n      }\n\n      .cls-144 {\n        fill: #033278;\n      }\n\n      .cls-145 {\n        fill: #215bd0;\n      }\n\n      .cls-146 {\n        fill: #6153f2;\n      }\n\n      .cls-147 {\n        fill: #0657b6;\n      }\n\n      .cls-148 {\n        fill: #6753f5;\n      }\n\n      .cls-149 {\n        fill: #6453f3;\n      }\n\n      .cls-150 {\n        fill: #4057e0;\n      }\n\n      .cls-151 {\n        fill: #05499f;\n      }\n\n      .cls-152 {\n        fill: #6a52f7;\n      }\n\n      .cls-153 {\n        fill: #032f73;\n      }\n\n      .cls-154 {\n        fill: none;\n      }\n\n      .cls-155 {\n        fill: #285ad4;\n      }\n\n      .cls-156 {\n        fill: #4d56e7;\n      }\n\n      .cls-157 {\n        fill: #2b5ad6;\n      }\n\n      .cls-158 {\n        fill: #0d5dc6;\n      }\n\n      .cls-159 {\n        fill: #6d52f8;\n      }\n\n      .cls-160 {\n        fill: #044090;\n      }\n\n      .cls-161 {\n        fill: #0658b8;\n      }\n\n      .cls-162 {\n        fill: #0e5dc6;\n      }\n\n      .cls-163 {\n        fill: #4956e5;\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-165 {\n        fill: #3758dc;\n      }\n\n      .cls-166 {\n        fill: #6253f2;\n      }\n\n      .cls-167 {\n        fill: #7052fa;\n      }\n\n      .cls-168 {\n        fill: #032a6a;\n      }\n\n      .cls-169 {\n        fill: #6553f4;\n      }\n\n      .cls-170 {\n        fill: #05499e;\n      }\n\n      .cls-171 {\n        fill: #054496;\n      }\n\n      .cls-172 {\n        fill: #032d70;\n      }\n\n      .cls-173 {\n        fill: #7152fa;\n      }\n\n      .cls-174 {\n        fill: #4457e3;\n      }\n\n      .cls-175 {\n        fill: #7152fb;\n      }\n\n      .cls-176 {\n        fill: #043f8e;\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-178 {\n        fill: #fdcfcf;\n      }\n\n      .cls-179 {\n        fill: #3a58dd;\n      }\n\n      .cls-180 {\n        fill: #0659ba;\n      }\n\n      .cls-181 {\n        fill: #043b88;\n      }\n\n      .cls-182 {\n        fill: #5f54f1;\n      }\n\n      .cls-183 {\n        fill: #043680;\n      }\n\n      .cls-184 {\n        fill: #054ba2;\n      }\n\n      .cls-185 {\n        fill: #5255ea;\n      }\n\n      .cls-186 {\n        fill: #5a54ee;\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-189 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-190 {\n        fill: #044192;\n      }\n\n      .cls-191 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-192 {\n        fill: #044293;\n      }\n\n      .cls-193 {\n        fill: #5355eb;\n      }\n\n      .cls-194 {\n        fill: #0658b9;\n      }\n\n      .cls-195 {\n        fill: #054aa1;\n      }\n\n      .cls-196 {\n        fill: #275ad3;\n      }\n\n      .cls-197 {\n        fill: #1c5bcd;\n      }\n\n      .cls-198 {\n        fill: #054598;\n      }\n\n      .cls-199 {\n        fill: #033075;\n      }\n\n      .cls-200 {\n        fill: #7251fb;\n      }\n\n      .cls-201 {\n        fill: #00b3f2;\n      }\n\n      .cls-202 {\n        fill: #05479c;\n      }\n\n      .cls-203 {\n        fill: #1e5bcf;\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-205 {\n        fill: #1d5bce;\n      }\n\n      .cls-206 {\n        fill: #2e59d7;\n      }\n\n      .cls-207 {\n        fill: #4f56e8;\n      }\n\n      .cls-208 {\n        fill: #6653f5;\n      }\n\n      .cls-209 {\n        fill: #4c56e7;\n      }\n\n      .cls-210 {\n        fill: #065bbd;\n      }\n\n      .cls-211 {\n        fill: #3559db;\n      }\n\n      .cls-212 {\n        fill: #044395;\n      }\n\n      .cls-213 {\n        fill: #3b58de;\n      }\n\n      .cls-214 {\n        fill: #044394;\n      }\n\n      .cls-215 {\n        fill: #115dc8;\n      }\n\n      .cls-216 {\n        fill: #4856e5;\n      }\n\n      .cls-217 {\n        fill: #065cbe;\n      }\n\n      .cls-218 {\n        fill: #3359d9;\n      }\n\n      .cls-219 {\n        fill: #0552ae;\n      }\n\n      .cls-220 {\n        fill: #054da6;\n      }\n\n      .cls-221 {\n        fill: #033074;\n      }\n\n      .cls-222 {\n        fill: #065dc1;\n      }\n\n      .cls-223 {\n        fill: #054ea7;\n      }\n\n      .cls-224 {\n        fill: #5655ec;\n      }\n\n      .cls-225 {\n        fill: #075ec3;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M13.32,201.99h12.84v10.08H0v-42.48H13.32v32.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M62.94,197.49h-21.42c.2,2.92,1.42,4.38,3.66,4.38,1.44,0,2.48-.66,3.12-1.98h14.1c-.48,2.4-1.49,4.55-3.03,6.45-1.54,1.9-3.48,3.4-5.82,4.5-2.34,1.1-4.91,1.65-7.71,1.65-3.36,0-6.35-.7-8.97-2.1-2.62-1.4-4.66-3.41-6.12-6.03s-2.19-5.69-2.19-9.21,.73-6.59,2.19-9.21,3.5-4.63,6.12-6.03c2.62-1.4,5.61-2.1,8.97-2.1s6.35,.69,8.97,2.07c2.62,1.38,4.66,3.35,6.12,5.91,1.46,2.56,2.19,5.58,2.19,9.06,0,.92-.06,1.8-.18,2.64Zm-13.32-5.82c0-1.12-.36-1.97-1.08-2.55-.72-.58-1.62-.87-2.7-.87-2.36,0-3.74,1.14-4.14,3.42h7.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M84.48,199.41l5.4-21.18h14.16l-11.28,33.84h-16.62l-11.28-33.84h14.16l5.46,21.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M140.16,197.49h-21.42c.2,2.92,1.42,4.38,3.66,4.38,1.44,0,2.48-.66,3.12-1.98h14.1c-.48,2.4-1.49,4.55-3.03,6.45-1.54,1.9-3.48,3.4-5.82,4.5-2.34,1.1-4.91,1.65-7.71,1.65-3.36,0-6.35-.7-8.97-2.1-2.62-1.4-4.66-3.41-6.12-6.03s-2.19-5.69-2.19-9.21,.73-6.59,2.19-9.21,3.5-4.63,6.12-6.03c2.62-1.4,5.61-2.1,8.97-2.1s6.35,.69,8.97,2.07c2.62,1.38,4.66,3.35,6.12,5.91,1.46,2.56,2.19,5.58,2.19,9.06,0,.92-.06,1.8-.18,2.64Zm-13.32-5.82c0-1.12-.36-1.97-1.08-2.55-.72-.58-1.62-.87-2.7-.87-2.36,0-3.74,1.14-4.14,3.42h7.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M157.86,167.67v44.4h-13.32v-44.4h13.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M176.88,169.59v23.94c0,1.96,.43,3.51,1.29,4.65,.86,1.14,2.25,1.71,4.17,1.71s3.34-.57,4.26-1.71c.92-1.14,1.38-2.69,1.38-4.65v-23.94h13.26v23.94c0,4.04-.84,7.49-2.52,10.35-1.68,2.86-3.98,5.01-6.9,6.45-2.92,1.44-6.18,2.16-9.78,2.16s-6.79-.72-9.57-2.16c-2.78-1.44-4.95-3.58-6.51-6.42-1.56-2.84-2.34-6.3-2.34-10.38v-23.94h13.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M223.95,179.16c1.58-.9,3.47-1.35,5.67-1.35,2.64,0,5.02,.69,7.14,2.07s3.79,3.38,5.01,6c1.22,2.62,1.83,5.71,1.83,9.27s-.61,6.65-1.83,9.27c-1.22,2.62-2.89,4.62-5.01,6-2.12,1.38-4.5,2.07-7.14,2.07-2.2,0-4.09-.45-5.67-1.35-1.58-.9-2.79-2.13-3.63-3.69v20.82h-13.32v-50.04h13.32v4.62c.84-1.56,2.05-2.79,3.63-3.69Zm4.77,11.79c-.92-1-2.1-1.5-3.54-1.5s-2.62,.5-3.54,1.5-1.38,2.4-1.38,4.2,.46,3.2,1.38,4.2,2.1,1.5,3.54,1.5,2.62-.5,3.54-1.5,1.38-2.4,1.38-4.2-.46-3.2-1.38-4.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M261.12,201.99h12.84v10.08h-26.16v-42.48h13.32v32.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M285.06,210.39c-2.72-1.4-4.85-3.41-6.39-6.03s-2.31-5.69-2.31-9.21,.77-6.59,2.31-9.21,3.67-4.63,6.39-6.03c2.72-1.4,5.78-2.1,9.18-2.1s6.46,.7,9.18,2.1c2.72,1.4,4.85,3.41,6.39,6.03,1.54,2.62,2.31,5.69,2.31,9.21s-.77,6.59-2.31,9.21c-1.54,2.62-3.67,4.63-6.39,6.03-2.72,1.4-5.78,2.1-9.18,2.1s-6.46-.7-9.18-2.1Zm12.3-10.89c.84-.98,1.26-2.43,1.26-4.35s-.42-3.37-1.26-4.35-1.88-1.47-3.12-1.47-2.28,.49-3.12,1.47-1.26,2.43-1.26,4.35,.41,3.37,1.23,4.35c.82,.98,1.87,1.47,3.15,1.47s2.28-.49,3.12-1.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M323.22,210.39c-2.72-1.4-4.85-3.41-6.39-6.03s-2.31-5.69-2.31-9.21,.77-6.59,2.31-9.21,3.67-4.63,6.39-6.03c2.72-1.4,5.78-2.1,9.18-2.1s6.46,.7,9.18,2.1c2.72,1.4,4.85,3.41,6.39,6.03,1.54,2.62,2.31,5.69,2.31,9.21s-.77,6.59-2.31,9.21c-1.54,2.62-3.67,4.63-6.39,6.03-2.72,1.4-5.78,2.1-9.18,2.1s-6.46-.7-9.18-2.1Zm12.3-10.89c.84-.98,1.26-2.43,1.26-4.35s-.42-3.37-1.26-4.35-1.88-1.47-3.12-1.47-2.28,.49-3.12,1.47-1.26,2.43-1.26,4.35,.41,3.37,1.23,4.35c.82,.98,1.87,1.47,3.15,1.47s2.28-.49,3.12-1.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M375.54,200.73v11.34h-5.04c-9.28,0-13.92-4.62-13.92-13.86v-8.88h-4.2v-11.1h4.2v-8.16h13.32v8.16h5.52v11.1h-5.52v9.12c0,.8,.19,1.38,.57,1.74,.38,.36,1.01,.54,1.89,.54h3.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M311.49,111.87l-29.46-83.61c-3.34-9.49-12.31-15.84-22.38-15.84H115.88c-10.06,0-19.03,6.35-22.38,15.84l-29.46,83.61c-7.63,21.67,8.44,44.38,31.42,44.38h0c10.28,0,19.98-4.75,26.29-12.86l19.1-24.56c11.26-14.47,28.57-22.94,46.91-22.94h0c18.34,0,35.65,8.47,46.91,22.94l19.1,24.56c6.31,8.11,16.01,12.86,26.29,12.86h0c22.97,0,39.05-22.71,31.42-44.38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M311.49,111.87l-29.46-83.61c-.63-1.78-1.45-3.45-2.44-4.99-4.3-6.66-11.76-10.86-19.93-10.86H115.88c-6.92,0-13.32,3-17.73,7.96-2.01,2.25-3.6,4.91-4.65,7.88l-29.46,83.61c-3.9,11.07-1.6,22.41,4.64,30.85l35.16-58.49c5.35-8.89,17.04-11.52,25.66-5.75,14.75,9.87,32.14,16.1,50.89,17.4h14.73c19.12-1.33,36.83-7.78,51.76-17.99,9.26-6.33,21.94-3.27,27.03,6.73l30.84,60.67c7.78-8.62,11.03-21.19,6.72-33.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M132.4,96.35c-26.56,0-48.18-21.61-48.18-48.18S105.84,0,132.4,0s48.18,21.61,48.18,48.18-21.61,48.18-48.18,48.18Zm0-90.58c-23.38,0-42.4,19.02-42.4,42.4s19.02,42.4,42.4,42.4,42.4-19.02,42.4-42.4S155.78,5.78,132.4,5.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M243.13,96.35c-26.56,0-48.18-21.61-48.18-48.18S216.56,0,243.13,0s48.18,21.61,48.18,48.18-21.61,48.18-48.18,48.18Zm0-90.58c-23.38,0-42.4,19.02-42.4,42.4s19.02,42.4,42.4,42.4,42.4-19.02,42.4-42.4S266.51,5.78,243.13,5.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M199.39,34.41c-13.27-7.81-22.81-.32-22.9-.24l-3.63-4.5c.51-.42,12.78-10.06,29.46-.24l-2.93,4.98Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M295.49,39.47h-7.07v5.78h7.07c1.6,0,2.89-1.29,2.89-2.89s-1.29-2.89-2.89-2.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M80.05,39.47c-1.6,0-2.89,1.29-2.89,2.89s1.29,2.89,2.89,2.89h7.07v-5.78h-7.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M209.83,119.67c-11.45,17.79-36.48,17.53-47.64-.39-2.11-3.38-7.47-.27-5.35,3.13,13.67,21.94,44.38,22.11,58.34,.39,2.17-3.37-3.2-6.48-5.35-3.13h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 229.59,
    cy: 160.03,
    r: 14.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.32,201.99h12.84v10.08H0v-42.48H13.32v32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.94,197.49h-21.42c.2,2.92,1.42,4.38,3.66,4.38,1.44,0,2.48-.66,3.12-1.98h14.1c-.48,2.4-1.49,4.55-3.03,6.45-1.54,1.9-3.48,3.4-5.82,4.5-2.34,1.1-4.91,1.65-7.71,1.65-3.36,0-6.35-.7-8.97-2.1-2.62-1.4-4.66-3.41-6.12-6.03s-2.19-5.69-2.19-9.21,.73-6.59,2.19-9.21,3.5-4.63,6.12-6.03c2.62-1.4,5.61-2.1,8.97-2.1s6.35,.69,8.97,2.07c2.62,1.38,4.66,3.35,6.12,5.91,1.46,2.56,2.19,5.58,2.19,9.06,0,.92-.06,1.8-.18,2.64Zm-13.32-5.82c0-1.12-.36-1.97-1.08-2.55-.72-.58-1.62-.87-2.7-.87-2.36,0-3.74,1.14-4.14,3.42h7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48,199.41l5.4-21.18h14.16l-11.28,33.84h-16.62l-11.28-33.84h14.16l5.46,21.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.16,197.49h-21.42c.2,2.92,1.42,4.38,3.66,4.38,1.44,0,2.48-.66,3.12-1.98h14.1c-.48,2.4-1.49,4.55-3.03,6.45-1.54,1.9-3.48,3.4-5.82,4.5-2.34,1.1-4.91,1.65-7.71,1.65-3.36,0-6.35-.7-8.97-2.1-2.62-1.4-4.66-3.41-6.12-6.03s-2.19-5.69-2.19-9.21,.73-6.59,2.19-9.21,3.5-4.63,6.12-6.03c2.62-1.4,5.61-2.1,8.97-2.1s6.35,.69,8.97,2.07c2.62,1.38,4.66,3.35,6.12,5.91,1.46,2.56,2.19,5.58,2.19,9.06,0,.92-.06,1.8-.18,2.64Zm-13.32-5.82c0-1.12-.36-1.97-1.08-2.55-.72-.58-1.62-.87-2.7-.87-2.36,0-3.74,1.14-4.14,3.42h7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.86,167.67v44.4h-13.32v-44.4h13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,169.59v23.94c0,1.96,.43,3.51,1.29,4.65,.86,1.14,2.25,1.71,4.17,1.71s3.34-.57,4.26-1.71c.92-1.14,1.38-2.69,1.38-4.65v-23.94h13.26v23.94c0,4.04-.84,7.49-2.52,10.35-1.68,2.86-3.98,5.01-6.9,6.45-2.92,1.44-6.18,2.16-9.78,2.16s-6.79-.72-9.57-2.16c-2.78-1.44-4.95-3.58-6.51-6.42-1.56-2.84-2.34-6.3-2.34-10.38v-23.94h13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.95,179.16c1.58-.9,3.47-1.35,5.67-1.35,2.64,0,5.02,.69,7.14,2.07s3.79,3.38,5.01,6c1.22,2.62,1.83,5.71,1.83,9.27s-.61,6.65-1.83,9.27c-1.22,2.62-2.89,4.62-5.01,6-2.12,1.38-4.5,2.07-7.14,2.07-2.2,0-4.09-.45-5.67-1.35-1.58-.9-2.79-2.13-3.63-3.69v20.82h-13.32v-50.04h13.32v4.62c.84-1.56,2.05-2.79,3.63-3.69Zm4.77,11.79c-.92-1-2.1-1.5-3.54-1.5s-2.62,.5-3.54,1.5-1.38,2.4-1.38,4.2,.46,3.2,1.38,4.2,2.1,1.5,3.54,1.5,2.62-.5,3.54-1.5,1.38-2.4,1.38-4.2-.46-3.2-1.38-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.12,201.99h12.84v10.08h-26.16v-42.48h13.32v32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,210.39c-2.72-1.4-4.85-3.41-6.39-6.03s-2.31-5.69-2.31-9.21,.77-6.59,2.31-9.21,3.67-4.63,6.39-6.03c2.72-1.4,5.78-2.1,9.18-2.1s6.46,.7,9.18,2.1c2.72,1.4,4.85,3.41,6.39,6.03,1.54,2.62,2.31,5.69,2.31,9.21s-.77,6.59-2.31,9.21c-1.54,2.62-3.67,4.63-6.39,6.03-2.72,1.4-5.78,2.1-9.18,2.1s-6.46-.7-9.18-2.1Zm12.3-10.89c.84-.98,1.26-2.43,1.26-4.35s-.42-3.37-1.26-4.35-1.88-1.47-3.12-1.47-2.28,.49-3.12,1.47-1.26,2.43-1.26,4.35,.41,3.37,1.23,4.35c.82,.98,1.87,1.47,3.15,1.47s2.28-.49,3.12-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,210.39c-2.72-1.4-4.85-3.41-6.39-6.03s-2.31-5.69-2.31-9.21,.77-6.59,2.31-9.21,3.67-4.63,6.39-6.03c2.72-1.4,5.78-2.1,9.18-2.1s6.46,.7,9.18,2.1c2.72,1.4,4.85,3.41,6.39,6.03,1.54,2.62,2.31,5.69,2.31,9.21s-.77,6.59-2.31,9.21c-1.54,2.62-3.67,4.63-6.39,6.03-2.72,1.4-5.78,2.1-9.18,2.1s-6.46-.7-9.18-2.1Zm12.3-10.89c.84-.98,1.26-2.43,1.26-4.35s-.42-3.37-1.26-4.35-1.88-1.47-3.12-1.47-2.28,.49-3.12,1.47-1.26,2.43-1.26,4.35,.41,3.37,1.23,4.35c.82,.98,1.87,1.47,3.15,1.47s2.28-.49,3.12-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,200.73v11.34h-5.04c-9.28,0-13.92-4.62-13.92-13.86v-8.88h-4.2v-11.1h4.2v-8.16h13.32v8.16h5.52v11.1h-5.52v9.12c0,.8,.19,1.38,.57,1.74,.38,.36,1.01,.54,1.89,.54h3.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    y: 212.04,
    width: 26.16,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    y: 211.5,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    y: 210.96,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    y: 210.41,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    y: 209.87,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    y: 209.33,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    y: 208.79,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    y: 208.25,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    y: 207.71,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    y: 207.17,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    y: 206.63,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    y: 206.09,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 205.54,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    y: 205,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    y: 204.46,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    y: 203.92,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    y: 203.38,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    y: 202.84,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    y: 202.3,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    y: 201.76,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    y: 201.22,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    y: 200.68,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    y: 200.13,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    y: 199.59,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    y: 199.05,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    y: 198.51,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    y: 197.97,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    y: 197.43,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    y: 196.89,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    y: 196.35,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    y: 195.81,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    y: 195.26,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    y: 194.72,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    y: 194.18,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    y: 193.64,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    y: 193.1,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    y: 192.56,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    y: 192.02,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    y: 191.48,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    y: 190.94,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    y: 190.39,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    y: 189.85,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    y: 189.31,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    y: 188.77,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    y: 188.23,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    y: 187.69,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    y: 187.15,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 186.61,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    y: 186.07,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    y: 185.52,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    y: 184.98,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    y: 184.44,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    y: 183.9,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    y: 183.36,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    y: 182.82,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    y: 182.28,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    y: 181.74,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    y: 181.2,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    y: 180.65,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    y: 180.11,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    y: 179.57,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    y: 179.03,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    y: 178.49,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    y: 177.95,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    y: 177.41,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    y: 176.87,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    y: 176.33,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    y: 175.79,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    y: 175.24,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    y: 174.7,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    y: 174.16,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    y: 173.62,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    y: 173.08,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 172.54,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    y: 172,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    y: 171.46,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    y: 170.92,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    y: 170.37,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    y: 169.83,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    y: 169.59,
    width: 26.16,
    height: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 41.7,
    y: 191.48,
    width: 7.92,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 41.7,
    y: 190.94,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 41.7,
    y: 190.39,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 41.7,
    y: 189.85,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 41.7,
    y: 189.31,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 41.7,
    y: 188.77,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 41.7,
    y: 188.25,
    width: 7.92,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 28.56,
    y: 212.04,
    width: 34.56,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 28.56,
    y: 211.5,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 28.56,
    y: 210.96,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 28.56,
    y: 210.41,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 28.56,
    y: 209.87,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 28.56,
    y: 209.33,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 28.56,
    y: 208.79,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 28.56,
    y: 208.25,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 28.56,
    y: 207.71,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 28.56,
    y: 207.17,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 28.56,
    y: 206.63,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 28.56,
    y: 206.09,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 28.56,
    y: 205.54,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 28.56,
    y: 205,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 28.56,
    y: 204.46,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 28.56,
    y: 203.92,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 28.56,
    y: 203.38,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 28.56,
    y: 202.84,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 28.56,
    y: 202.3,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 28.56,
    y: 201.76,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 28.56,
    y: 201.22,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 28.56,
    y: 200.68,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 28.56,
    y: 200.13,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.56,
    y: 199.59,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 28.56,
    y: 199.05,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 28.56,
    y: 198.51,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 28.56,
    y: 197.97,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 28.56,
    y: 197.43,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 28.56,
    y: 196.89,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 28.56,
    y: 196.35,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 28.56,
    y: 195.81,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 28.56,
    y: 195.26,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 28.56,
    y: 194.72,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 28.56,
    y: 194.18,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 28.56,
    y: 193.64,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 28.56,
    y: 193.1,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 28.56,
    y: 192.56,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 28.56,
    y: 192.02,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 28.56,
    y: 191.48,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 28.56,
    y: 190.94,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 28.56,
    y: 190.39,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 28.56,
    y: 189.85,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 28.56,
    y: 189.31,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 28.56,
    y: 188.77,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 28.56,
    y: 188.23,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 28.56,
    y: 187.69,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 28.56,
    y: 187.15,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.56,
    y: 186.61,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 28.56,
    y: 186.07,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 28.56,
    y: 185.52,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 28.56,
    y: 184.98,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 28.56,
    y: 184.44,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 28.56,
    y: 183.9,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 28.56,
    y: 183.36,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 28.56,
    y: 182.82,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 28.56,
    y: 182.28,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 28.56,
    y: 181.74,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 28.56,
    y: 181.2,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 28.56,
    y: 180.65,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 28.56,
    y: 180.11,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 28.56,
    y: 179.57,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 28.56,
    y: 179.03,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 28.56,
    y: 178.49,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 28.56,
    y: 177.95,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 28.56,
    y: 177.81,
    width: 34.56,
    height: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 64.86,
    y: 212.04,
    width: 39.18,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 64.86,
    y: 211.5,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 64.86,
    y: 210.96,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 64.86,
    y: 210.41,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 64.86,
    y: 209.87,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 64.86,
    y: 209.33,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 64.86,
    y: 208.79,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 64.86,
    y: 208.25,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 64.86,
    y: 207.71,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 64.86,
    y: 207.17,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 64.86,
    y: 206.63,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 64.86,
    y: 206.09,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 64.86,
    y: 205.54,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 64.86,
    y: 205,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 64.86,
    y: 204.46,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 64.86,
    y: 203.92,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 64.86,
    y: 203.38,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 64.86,
    y: 202.84,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 64.86,
    y: 202.3,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 64.86,
    y: 201.76,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 64.86,
    y: 201.22,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 64.86,
    y: 200.68,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 64.86,
    y: 200.13,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 64.86,
    y: 199.59,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 64.86,
    y: 199.05,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 64.86,
    y: 198.51,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 64.86,
    y: 197.97,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 64.86,
    y: 197.43,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 64.86,
    y: 196.89,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 64.86,
    y: 196.35,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 64.86,
    y: 195.81,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 64.86,
    y: 195.26,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 64.86,
    y: 194.72,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 64.86,
    y: 194.18,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 64.86,
    y: 193.64,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 64.86,
    y: 193.1,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 64.86,
    y: 192.56,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 64.86,
    y: 192.02,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 64.86,
    y: 191.48,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 64.86,
    y: 190.94,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 64.86,
    y: 190.39,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 64.86,
    y: 189.85,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 64.86,
    y: 189.31,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 64.86,
    y: 188.77,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 64.86,
    y: 188.23,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 64.86,
    y: 187.69,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 64.86,
    y: 187.15,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.86,
    y: 186.61,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 64.86,
    y: 186.07,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 64.86,
    y: 185.52,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 64.86,
    y: 184.98,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 64.86,
    y: 184.44,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 64.86,
    y: 183.9,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 64.86,
    y: 183.36,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 64.86,
    y: 182.82,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 64.86,
    y: 182.28,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 64.86,
    y: 181.74,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 64.86,
    y: 181.2,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 64.86,
    y: 180.65,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 64.86,
    y: 180.11,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 64.86,
    y: 179.57,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 64.86,
    y: 179.03,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 64.86,
    y: 178.49,
    width: 39.18,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 64.86,
    y: 178.23,
    width: 39.18,
    height: 0.26
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 118.92,
    y: 191.48,
    width: 7.92,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 118.92,
    y: 190.94,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 118.92,
    y: 190.39,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 118.92,
    y: 189.85,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 118.92,
    y: 189.31,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 118.92,
    y: 188.77,
    width: 7.92,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 118.92,
    y: 188.25,
    width: 7.92,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 105.78,
    y: 212.04,
    width: 34.56,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 105.78,
    y: 211.5,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 105.78,
    y: 210.96,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 105.78,
    y: 210.41,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 105.78,
    y: 209.87,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 105.78,
    y: 209.33,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 105.78,
    y: 208.79,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 105.78,
    y: 208.25,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 105.78,
    y: 207.71,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 105.78,
    y: 207.17,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 105.78,
    y: 206.63,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 105.78,
    y: 206.09,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 105.78,
    y: 205.54,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 105.78,
    y: 205,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 105.78,
    y: 204.46,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 105.78,
    y: 203.92,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 105.78,
    y: 203.38,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 105.78,
    y: 202.84,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 105.78,
    y: 202.3,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 105.78,
    y: 201.76,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 105.78,
    y: 201.22,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 105.78,
    y: 200.68,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 105.78,
    y: 200.13,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 105.78,
    y: 199.59,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 105.78,
    y: 199.05,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 105.78,
    y: 198.51,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 105.78,
    y: 197.97,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 105.78,
    y: 197.43,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 105.78,
    y: 196.89,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 105.78,
    y: 196.35,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 105.78,
    y: 195.81,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 105.78,
    y: 195.26,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 105.78,
    y: 194.72,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 105.78,
    y: 194.18,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 105.78,
    y: 193.64,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 105.78,
    y: 193.1,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 105.78,
    y: 192.56,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 105.78,
    y: 192.02,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 105.78,
    y: 191.48,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 105.78,
    y: 190.94,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 105.78,
    y: 190.39,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 105.78,
    y: 189.85,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 105.78,
    y: 189.31,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 105.78,
    y: 188.77,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 105.78,
    y: 188.23,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 105.78,
    y: 187.69,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 105.78,
    y: 187.15,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.78,
    y: 186.61,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 105.78,
    y: 186.07,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 105.78,
    y: 185.52,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 105.78,
    y: 184.98,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 105.78,
    y: 184.44,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 105.78,
    y: 183.9,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 105.78,
    y: 183.36,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 105.78,
    y: 182.82,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 105.78,
    y: 182.28,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 105.78,
    y: 181.74,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 105.78,
    y: 181.2,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 105.78,
    y: 180.65,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 105.78,
    y: 180.11,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 105.78,
    y: 179.57,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 105.78,
    y: 179.03,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 105.78,
    y: 178.49,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 105.78,
    y: 177.95,
    width: 34.56,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 105.78,
    y: 177.81,
    width: 34.56,
    height: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 144.54,
    y: 212.04,
    width: 13.32,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 144.54,
    y: 211.5,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 144.54,
    y: 210.96,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 144.54,
    y: 210.41,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 144.54,
    y: 209.87,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 144.54,
    y: 209.33,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 144.54,
    y: 208.79,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 144.54,
    y: 208.25,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 144.54,
    y: 207.71,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 144.54,
    y: 207.17,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 144.54,
    y: 206.63,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 144.54,
    y: 206.09,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 144.54,
    y: 205.54,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 144.54,
    y: 205,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 144.54,
    y: 204.46,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 144.54,
    y: 203.92,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 144.54,
    y: 203.38,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 144.54,
    y: 202.84,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 144.54,
    y: 202.3,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 144.54,
    y: 201.76,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 144.54,
    y: 201.22,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 144.54,
    y: 200.68,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 144.54,
    y: 200.13,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 144.54,
    y: 199.59,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 144.54,
    y: 199.05,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 144.54,
    y: 198.51,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 144.54,
    y: 197.97,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 144.54,
    y: 197.43,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 144.54,
    y: 196.89,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 144.54,
    y: 196.35,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 144.54,
    y: 195.81,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 144.54,
    y: 195.26,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 144.54,
    y: 194.72,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 144.54,
    y: 194.18,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 144.54,
    y: 193.64,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 144.54,
    y: 193.1,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 144.54,
    y: 192.56,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 144.54,
    y: 192.02,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 144.54,
    y: 191.48,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 144.54,
    y: 190.94,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 144.54,
    y: 190.39,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 144.54,
    y: 189.85,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 144.54,
    y: 189.31,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 144.54,
    y: 188.77,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 144.54,
    y: 188.23,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 144.54,
    y: 187.69,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 144.54,
    y: 187.15,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.54,
    y: 186.61,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 144.54,
    y: 186.07,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 144.54,
    y: 185.52,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 144.54,
    y: 184.98,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 144.54,
    y: 184.44,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 144.54,
    y: 183.9,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 144.54,
    y: 183.36,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 144.54,
    y: 182.82,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 144.54,
    y: 182.28,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 144.54,
    y: 181.74,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 144.54,
    y: 181.2,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 144.54,
    y: 180.65,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 144.54,
    y: 180.11,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 144.54,
    y: 179.57,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 144.54,
    y: 179.03,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 144.54,
    y: 178.49,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 144.54,
    y: 177.95,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 144.54,
    y: 177.41,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 144.54,
    y: 176.87,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 144.54,
    y: 176.33,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 144.54,
    y: 175.79,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 144.54,
    y: 175.24,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 144.54,
    y: 174.7,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 144.54,
    y: 174.16,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 144.54,
    y: 173.62,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 144.54,
    y: 173.08,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 144.54,
    y: 172.54,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 144.54,
    y: 172,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 144.54,
    y: 171.46,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 144.54,
    y: 170.92,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 144.54,
    y: 170.37,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 144.54,
    y: 169.83,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 144.54,
    y: 169.29,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 144.54,
    y: 168.75,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 144.54,
    y: 168.21,
    width: 13.32,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.54,
    y: 167.67,
    width: 13.32,
    height: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 163.62,
    y: 212.04,
    width: 37.62,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 163.62,
    y: 211.5,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 163.62,
    y: 210.96,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 163.62,
    y: 210.41,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 163.62,
    y: 209.87,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 163.62,
    y: 209.33,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 163.62,
    y: 208.79,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 163.62,
    y: 208.25,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.62,
    y: 207.71,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 163.62,
    y: 207.17,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 163.62,
    y: 206.63,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 163.62,
    y: 206.09,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 163.62,
    y: 205.54,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 163.62,
    y: 205,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 163.62,
    y: 204.46,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 163.62,
    y: 203.92,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 163.62,
    y: 203.38,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 163.62,
    y: 202.84,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 163.62,
    y: 202.3,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 163.62,
    y: 201.76,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 163.62,
    y: 201.22,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 163.62,
    y: 200.68,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 163.62,
    y: 200.13,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 163.62,
    y: 199.59,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 163.62,
    y: 199.05,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 163.62,
    y: 198.51,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 163.62,
    y: 197.97,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 163.62,
    y: 197.43,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 163.62,
    y: 196.89,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 163.62,
    y: 196.35,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 163.62,
    y: 195.81,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 163.62,
    y: 195.26,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 163.62,
    y: 194.72,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 163.62,
    y: 194.18,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 163.62,
    y: 193.64,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 163.62,
    y: 193.1,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 163.62,
    y: 192.56,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 163.62,
    y: 192.02,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 163.62,
    y: 191.48,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 163.62,
    y: 190.94,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 163.62,
    y: 190.39,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 163.62,
    y: 189.85,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 163.62,
    y: 189.31,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 163.62,
    y: 188.77,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 163.62,
    y: 188.23,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 163.62,
    y: 187.69,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 163.62,
    y: 187.15,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.62,
    y: 186.61,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 163.62,
    y: 186.07,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 163.62,
    y: 185.52,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 163.62,
    y: 184.98,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 163.62,
    y: 184.44,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 163.62,
    y: 183.9,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 163.62,
    y: 183.36,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 163.62,
    y: 182.82,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 163.62,
    y: 182.28,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 163.62,
    y: 181.74,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 163.62,
    y: 181.2,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 163.62,
    y: 180.65,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 163.62,
    y: 180.11,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 163.62,
    y: 179.57,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 163.62,
    y: 179.03,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 163.62,
    y: 178.49,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 163.62,
    y: 177.95,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 163.62,
    y: 177.41,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 163.62,
    y: 176.87,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 163.62,
    y: 176.33,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 163.62,
    y: 175.79,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 163.62,
    y: 175.24,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 163.62,
    y: 174.7,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 163.62,
    y: 174.16,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 163.62,
    y: 173.62,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 163.62,
    y: 173.08,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 163.62,
    y: 172.54,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 163.62,
    y: 172,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 163.62,
    y: 171.46,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 163.62,
    y: 170.92,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 163.62,
    y: 170.37,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 163.62,
    y: 169.83,
    width: 37.62,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 163.62,
    y: 169.59,
    width: 37.62,
    height: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 220.26,
    y: 200.68,
    width: 9.84,
    height: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 220.26,
    y: 200.13,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 220.26,
    y: 199.59,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 220.26,
    y: 199.05,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 220.26,
    y: 198.51,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 220.26,
    y: 197.97,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 220.26,
    y: 197.43,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 220.26,
    y: 196.89,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 220.26,
    y: 196.35,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 220.26,
    y: 195.81,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 220.26,
    y: 195.26,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 220.26,
    y: 194.72,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 220.26,
    y: 194.18,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 220.26,
    y: 193.64,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 220.26,
    y: 193.1,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 220.26,
    y: 192.56,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 220.26,
    y: 192.02,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 220.26,
    y: 191.48,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 220.26,
    y: 190.94,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 220.26,
    y: 190.39,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 220.26,
    y: 189.85,
    width: 9.84,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 220.26,
    y: 189.45,
    width: 9.84,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 207,
    y: 227.73,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 207,
    y: 227.19,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 207,
    y: 226.65,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 207,
    y: 226.11,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 207,
    y: 225.57,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 207,
    y: 225.02,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 207,
    y: 224.48,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 207,
    y: 223.94,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 207,
    y: 223.4,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 207,
    y: 222.86,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 207,
    y: 222.32,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 207,
    y: 221.78,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 207,
    y: 221.24,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 207,
    y: 220.7,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 207,
    y: 220.15,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 207,
    y: 219.61,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 207,
    y: 219.07,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 207,
    y: 218.53,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 207,
    y: 217.99,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 207,
    y: 217.45,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 207,
    y: 216.91,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 207,
    y: 216.37,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 207,
    y: 215.83,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 207,
    y: 215.28,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 207,
    y: 214.74,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 207,
    y: 214.2,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 207,
    y: 213.66,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 207,
    y: 213.12,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 207,
    y: 212.58,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 207,
    y: 212.04,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 207,
    y: 211.5,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 207,
    y: 210.96,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 207,
    y: 210.41,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 207,
    y: 209.87,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 207,
    y: 209.33,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 207,
    y: 208.79,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 207,
    y: 208.25,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 207,
    y: 207.71,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 207,
    y: 207.17,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 207,
    y: 206.63,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 207,
    y: 206.09,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 207,
    y: 205.54,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 207,
    y: 205,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 207,
    y: 204.46,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 207,
    y: 203.92,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 207,
    y: 203.38,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 207,
    y: 202.84,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 207,
    y: 202.3,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 207,
    y: 201.76,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 207,
    y: 201.22,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 207,
    y: 200.68,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 207,
    y: 200.13,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 207,
    y: 199.59,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 207,
    y: 199.05,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 207,
    y: 198.51,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 207,
    y: 197.97,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 207,
    y: 197.43,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 207,
    y: 196.89,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 207,
    y: 196.35,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 207,
    y: 195.81,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 207,
    y: 195.26,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 207,
    y: 194.72,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 207,
    y: 194.18,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 207,
    y: 193.64,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 207,
    y: 193.1,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 207,
    y: 192.56,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 207,
    y: 192.02,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 207,
    y: 191.48,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 207,
    y: 190.94,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 207,
    y: 190.39,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 207,
    y: 189.85,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 207,
    y: 189.31,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 207,
    y: 188.77,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 207,
    y: 188.23,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 207,
    y: 187.69,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 207,
    y: 187.15,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 207,
    y: 186.61,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 207,
    y: 186.07,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 207,
    y: 185.52,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 207,
    y: 184.98,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 207,
    y: 184.44,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 207,
    y: 183.9,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 207,
    y: 183.36,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 207,
    y: 182.82,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 207,
    y: 182.28,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 207,
    y: 181.74,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 207,
    y: 181.2,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 207,
    y: 180.65,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 207,
    y: 180.11,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 207,
    y: 179.57,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 207,
    y: 179.03,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 207,
    y: 178.49,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 207,
    y: 177.95,
    width: 36.6,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 207,
    y: 177.81,
    width: 36.6,
    height: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 247.8,
    y: 212.04,
    width: 26.16,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 247.8,
    y: 211.5,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 247.8,
    y: 210.96,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 247.8,
    y: 210.41,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 247.8,
    y: 209.87,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 247.8,
    y: 209.33,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 247.8,
    y: 208.79,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 247.8,
    y: 208.25,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 247.8,
    y: 207.71,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 247.8,
    y: 207.17,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 247.8,
    y: 206.63,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 247.8,
    y: 206.09,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 247.8,
    y: 205.54,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 247.8,
    y: 205,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 247.8,
    y: 204.46,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 247.8,
    y: 203.92,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 247.8,
    y: 203.38,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 247.8,
    y: 202.84,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 247.8,
    y: 202.3,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 247.8,
    y: 201.76,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 247.8,
    y: 201.22,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 247.8,
    y: 200.68,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 247.8,
    y: 200.13,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 247.8,
    y: 199.59,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 247.8,
    y: 199.05,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 247.8,
    y: 198.51,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 247.8,
    y: 197.97,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 247.8,
    y: 197.43,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 247.8,
    y: 196.89,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 247.8,
    y: 196.35,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 247.8,
    y: 195.81,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 247.8,
    y: 195.26,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 247.8,
    y: 194.72,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 247.8,
    y: 194.18,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 247.8,
    y: 193.64,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 247.8,
    y: 193.1,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 247.8,
    y: 192.56,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 247.8,
    y: 192.02,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 247.8,
    y: 191.48,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 247.8,
    y: 190.94,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 247.8,
    y: 190.39,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 247.8,
    y: 189.85,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 247.8,
    y: 189.31,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 247.8,
    y: 188.77,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 247.8,
    y: 188.23,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 247.8,
    y: 187.69,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 247.8,
    y: 187.15,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.8,
    y: 186.61,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 247.8,
    y: 186.07,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 247.8,
    y: 185.52,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 247.8,
    y: 184.98,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 247.8,
    y: 184.44,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 247.8,
    y: 183.9,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 247.8,
    y: 183.36,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 247.8,
    y: 182.82,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 247.8,
    y: 182.28,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 247.8,
    y: 181.74,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 247.8,
    y: 181.2,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 247.8,
    y: 180.65,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 247.8,
    y: 180.11,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 247.8,
    y: 179.57,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 247.8,
    y: 179.03,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 247.8,
    y: 178.49,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 247.8,
    y: 177.95,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 247.8,
    y: 177.41,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 247.8,
    y: 176.87,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 247.8,
    y: 176.33,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 247.8,
    y: 175.79,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 247.8,
    y: 175.24,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 247.8,
    y: 174.7,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 247.8,
    y: 174.16,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 247.8,
    y: 173.62,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 247.8,
    y: 173.08,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.8,
    y: 172.54,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 247.8,
    y: 172,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 247.8,
    y: 171.46,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 247.8,
    y: 170.92,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 247.8,
    y: 170.37,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 247.8,
    y: 169.83,
    width: 26.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 247.8,
    y: 169.59,
    width: 26.16,
    height: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 289.86,
    y: 200.68,
    width: 8.76,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 289.86,
    y: 200.13,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 289.86,
    y: 199.59,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 289.86,
    y: 199.05,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 289.86,
    y: 198.51,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 289.86,
    y: 197.97,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 289.86,
    y: 197.43,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 289.86,
    y: 196.89,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 289.86,
    y: 196.35,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 289.86,
    y: 195.81,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 289.86,
    y: 195.26,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 289.86,
    y: 194.72,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 289.86,
    y: 194.18,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 289.86,
    y: 193.64,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 289.86,
    y: 193.1,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 289.86,
    y: 192.56,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 289.86,
    y: 192.02,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 289.86,
    y: 191.48,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 289.86,
    y: 190.94,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 289.86,
    y: 190.39,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 289.86,
    y: 189.85,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 289.86,
    y: 189.33,
    width: 8.76,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 276.36,
    y: 212.04,
    width: 35.76,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 276.36,
    y: 211.5,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 276.36,
    y: 210.96,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 276.36,
    y: 210.41,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 276.36,
    y: 209.87,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 276.36,
    y: 209.33,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 276.36,
    y: 208.79,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 276.36,
    y: 208.25,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 276.36,
    y: 207.71,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 276.36,
    y: 207.17,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 276.36,
    y: 206.63,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 276.36,
    y: 206.09,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 276.36,
    y: 205.54,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 276.36,
    y: 205,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 276.36,
    y: 204.46,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 276.36,
    y: 203.92,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 276.36,
    y: 203.38,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 276.36,
    y: 202.84,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 276.36,
    y: 202.3,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 276.36,
    y: 201.76,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 276.36,
    y: 201.22,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 276.36,
    y: 200.68,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 276.36,
    y: 200.13,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 276.36,
    y: 199.59,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 276.36,
    y: 199.05,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 276.36,
    y: 198.51,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 276.36,
    y: 197.97,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 276.36,
    y: 197.43,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 276.36,
    y: 196.89,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 276.36,
    y: 196.35,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 276.36,
    y: 195.81,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 276.36,
    y: 195.26,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 276.36,
    y: 194.72,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 276.36,
    y: 194.18,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 276.36,
    y: 193.64,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 276.36,
    y: 193.1,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 276.36,
    y: 192.56,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 276.36,
    y: 192.02,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 276.36,
    y: 191.48,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 276.36,
    y: 190.94,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 276.36,
    y: 190.39,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 276.36,
    y: 189.85,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 276.36,
    y: 189.31,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 276.36,
    y: 188.77,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 276.36,
    y: 188.23,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 276.36,
    y: 187.69,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 276.36,
    y: 187.15,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 276.36,
    y: 186.61,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 276.36,
    y: 186.07,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 276.36,
    y: 185.52,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 276.36,
    y: 184.98,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 276.36,
    y: 184.44,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 276.36,
    y: 183.9,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 276.36,
    y: 183.36,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 276.36,
    y: 182.82,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 276.36,
    y: 182.28,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 276.36,
    y: 181.74,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 276.36,
    y: 181.2,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 276.36,
    y: 180.65,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 276.36,
    y: 180.11,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 276.36,
    y: 179.57,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 276.36,
    y: 179.03,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 276.36,
    y: 178.49,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 276.36,
    y: 177.95,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 276.36,
    y: 177.81,
    width: 35.76,
    height: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 328.02,
    y: 200.68,
    width: 8.76,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 328.02,
    y: 200.13,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 328.02,
    y: 199.59,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 328.02,
    y: 199.05,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 328.02,
    y: 198.51,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 328.02,
    y: 197.97,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 328.02,
    y: 197.43,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 328.02,
    y: 196.89,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 328.02,
    y: 196.35,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 328.02,
    y: 195.81,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 328.02,
    y: 195.26,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 328.02,
    y: 194.72,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 328.02,
    y: 194.18,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 328.02,
    y: 193.64,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 328.02,
    y: 193.1,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 328.02,
    y: 192.56,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 328.02,
    y: 192.02,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 328.02,
    y: 191.48,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 328.02,
    y: 190.94,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 328.02,
    y: 190.39,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 328.02,
    y: 189.85,
    width: 8.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 328.02,
    y: 189.33,
    width: 8.76,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 314.52,
    y: 212.04,
    width: 35.76,
    height: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 314.52,
    y: 211.5,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 314.52,
    y: 210.96,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 314.52,
    y: 210.41,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 314.52,
    y: 209.87,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 314.52,
    y: 209.33,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 314.52,
    y: 208.79,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 314.52,
    y: 208.25,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 314.52,
    y: 207.71,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 314.52,
    y: 207.17,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 314.52,
    y: 206.63,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 314.52,
    y: 206.09,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 314.52,
    y: 205.54,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 314.52,
    y: 205,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 314.52,
    y: 204.46,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 314.52,
    y: 203.92,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 314.52,
    y: 203.38,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 314.52,
    y: 202.84,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 314.52,
    y: 202.3,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 314.52,
    y: 201.76,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 314.52,
    y: 201.22,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 314.52,
    y: 200.68,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 314.52,
    y: 200.13,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 314.52,
    y: 199.59,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 314.52,
    y: 199.05,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 314.52,
    y: 198.51,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 314.52,
    y: 197.97,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 314.52,
    y: 197.43,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 314.52,
    y: 196.89,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 314.52,
    y: 196.35,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 314.52,
    y: 195.81,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 314.52,
    y: 195.26,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 314.52,
    y: 194.72,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 314.52,
    y: 194.18,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 314.52,
    y: 193.64,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 314.52,
    y: 193.1,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 314.52,
    y: 192.56,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 314.52,
    y: 192.02,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 314.52,
    y: 191.48,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 314.52,
    y: 190.94,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 314.52,
    y: 190.39,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 314.52,
    y: 189.85,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 314.52,
    y: 189.31,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 314.52,
    y: 188.77,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 314.52,
    y: 188.23,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 314.52,
    y: 187.69,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 314.52,
    y: 187.15,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 314.52,
    y: 186.61,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 314.52,
    y: 186.07,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 314.52,
    y: 185.52,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 314.52,
    y: 184.98,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 314.52,
    y: 184.44,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 314.52,
    y: 183.9,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 314.52,
    y: 183.36,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 314.52,
    y: 182.82,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 314.52,
    y: 182.28,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 314.52,
    y: 181.74,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 314.52,
    y: 181.2,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 314.52,
    y: 180.65,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 314.52,
    y: 180.11,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 314.52,
    y: 179.57,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 314.52,
    y: 179.03,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 314.52,
    y: 178.49,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 314.52,
    y: 177.95,
    width: 35.76,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 314.52,
    y: 177.81,
    width: 35.76,
    height: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 352.38,
    y: 212.04,
    width: 23.16,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 352.38,
    y: 211.5,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 352.38,
    y: 210.96,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 352.38,
    y: 210.41,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 352.38,
    y: 209.87,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 352.38,
    y: 209.33,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 352.38,
    y: 208.79,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 352.38,
    y: 208.25,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 352.38,
    y: 207.71,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 352.38,
    y: 207.17,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 352.38,
    y: 206.63,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 352.38,
    y: 206.09,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 352.38,
    y: 205.54,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 352.38,
    y: 205,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 352.38,
    y: 204.46,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 352.38,
    y: 203.92,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 352.38,
    y: 203.38,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 352.38,
    y: 202.84,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 352.38,
    y: 202.3,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 352.38,
    y: 201.76,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 352.38,
    y: 201.22,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 352.38,
    y: 200.68,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 352.38,
    y: 200.13,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 352.38,
    y: 199.59,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 352.38,
    y: 199.05,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 352.38,
    y: 198.51,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 352.38,
    y: 197.97,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 352.38,
    y: 197.43,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 352.38,
    y: 196.89,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 352.38,
    y: 196.35,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 352.38,
    y: 195.81,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 352.38,
    y: 195.26,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 352.38,
    y: 194.72,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 352.38,
    y: 194.18,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 352.38,
    y: 193.64,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 352.38,
    y: 193.1,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 352.38,
    y: 192.56,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 352.38,
    y: 192.02,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 352.38,
    y: 191.48,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 352.38,
    y: 190.94,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 352.38,
    y: 190.39,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 352.38,
    y: 189.85,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 352.38,
    y: 189.31,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 352.38,
    y: 188.77,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 352.38,
    y: 188.23,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 352.38,
    y: 187.69,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 352.38,
    y: 187.15,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352.38,
    y: 186.61,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 352.38,
    y: 186.07,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 352.38,
    y: 185.52,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 352.38,
    y: 184.98,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 352.38,
    y: 184.44,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 352.38,
    y: 183.9,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 352.38,
    y: 183.36,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 352.38,
    y: 182.82,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 352.38,
    y: 182.28,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 352.38,
    y: 181.74,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 352.38,
    y: 181.2,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 352.38,
    y: 180.65,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.38,
    y: 180.11,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 352.38,
    y: 179.57,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 352.38,
    y: 179.03,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 352.38,
    y: 178.49,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 352.38,
    y: 177.95,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 352.38,
    y: 177.41,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 352.38,
    y: 176.87,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 352.38,
    y: 176.33,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 352.38,
    y: 175.79,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 352.38,
    y: 175.24,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 352.38,
    y: 174.7,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 352.38,
    y: 174.16,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 352.38,
    y: 173.62,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 352.38,
    y: 173.08,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 352.38,
    y: 172.54,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 352.38,
    y: 172,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 352.38,
    y: 171.46,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 352.38,
    y: 170.92,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 352.38,
    y: 170.37,
    width: 23.16,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 352.38,
    y: 170.07,
    width: 23.16,
    height: 0.31
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M59.52,224.64c-1.75-1.75-4.58-1.75-6.33,0l-4.39,4.39-4.39-4.39c-1.75-1.75-4.58-1.75-6.33,0-1.75,1.75-1.75,4.58,0,6.33l4.39,4.39-4.39,4.39c-1.75,1.75-1.75,4.58,0,6.33,1.75,1.75,4.58,1.75,6.33,0l4.39-4.39,4.39,4.39c1.75,1.75,4.58,1.75,6.33,0s1.75-4.58,0-6.33l-4.39-4.39,4.39-4.39c1.75-1.75,1.75-4.58,0-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M384.25,139.36l4.39-4.39c1.75-1.75,1.75-4.58,0-6.33-1.75-1.75-4.58-1.75-6.33,0l-4.39,4.39-4.39-4.39c-1.75-1.75-4.58-1.75-6.33,0-1.75,1.75-1.75,4.58,0,6.33l4.39,4.39-4.39,4.39c-1.75,1.75-1.75,4.58,0,6.33,1.75,1.75,4.58,1.75,6.33,0l4.39-4.39,4.39,4.39c1.75,1.75,4.58,1.75,6.33,0,1.75-1.75,1.75-4.58,0-6.33l-4.39-4.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M311.49,111.87l-29.46-83.61c-3.34-9.49-12.31-15.84-22.38-15.84H115.88c-10.06,0-19.03,6.35-22.38,15.84l-29.46,83.61c-7.63,21.67,8.44,44.38,31.42,44.38h0c10.28,0,19.98-4.75,26.29-12.86l36.95-47.5h58.13l36.95,47.5c6.31,8.11,16.01,12.86,26.29,12.86h0c22.97,0,39.05-22.71,31.42-44.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M282.03,28.27c-3.34-9.49-12.31-15.84-22.38-15.84H115.88c-10.06,0-19.03,6.35-22.38,15.84-1.21,3.44-.96,7.22,.69,10.47,16.29,32,48.5,54.53,86.21,57.15h14.73c37.7-2.62,69.92-25.15,86.21-57.15,1.65-3.25,1.9-7.03,.69-10.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 56.41,
    y: 12.42,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 56.41,
    y: 13.71,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 56.41,
    y: 14.99,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 56.41,
    y: 16.28,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 56.41,
    y: 17.56,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 56.41,
    y: 18.84,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 56.41,
    y: 20.13,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 56.41,
    y: 21.41,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 56.41,
    y: 22.7,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 56.41,
    y: 23.98,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 56.41,
    y: 25.27,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 56.41,
    y: 26.55,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 56.41,
    y: 27.83,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 56.41,
    y: 29.12,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 56.41,
    y: 30.4,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 56.41,
    y: 31.69,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 56.41,
    y: 32.97,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 56.41,
    y: 34.25,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.41,
    y: 35.54,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 56.41,
    y: 36.82,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 56.41,
    y: 38.11,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 56.41,
    y: 39.39,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 56.41,
    y: 40.68,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 56.41,
    y: 41.96,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 56.41,
    y: 43.24,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 56.41,
    y: 44.53,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 56.41,
    y: 45.81,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 56.41,
    y: 47.1,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 56.41,
    y: 48.38,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 56.41,
    y: 49.66,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 56.41,
    y: 50.95,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 56.41,
    y: 52.23,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 56.41,
    y: 53.52,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 56.41,
    y: 54.8,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 56.41,
    y: 56.09,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 56.41,
    y: 57.37,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 56.41,
    y: 58.65,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 56.41,
    y: 59.94,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 56.41,
    y: 61.22,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 56.41,
    y: 62.51,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 56.41,
    y: 63.79,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 56.41,
    y: 65.07,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 56.41,
    y: 66.36,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 56.41,
    y: 67.64,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 56.41,
    y: 68.93,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 56.41,
    y: 70.21,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 56.41,
    y: 71.5,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 56.41,
    y: 72.78,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 56.41,
    y: 74.06,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 56.41,
    y: 75.35,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 56.41,
    y: 76.63,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 56.41,
    y: 77.92,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 56.41,
    y: 79.2,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 56.41,
    y: 80.48,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 56.41,
    y: 81.77,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 56.41,
    y: 83.05,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 56.41,
    y: 84.34,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 56.41,
    y: 85.62,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 56.41,
    y: 86.91,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 56.41,
    y: 88.19,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 56.41,
    y: 89.47,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 56.41,
    y: 90.76,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 56.41,
    y: 92.04,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 56.41,
    y: 93.33,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 56.41,
    y: 94.61,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 56.41,
    y: 95.89,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 56.41,
    y: 97.18,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 56.41,
    y: 98.46,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 56.41,
    y: 99.75,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 56.41,
    y: 101.03,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 56.41,
    y: 102.32,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 56.41,
    y: 103.6,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 56.41,
    y: 104.88,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 56.41,
    y: 106.17,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 56.41,
    y: 107.45,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 56.41,
    y: 108.74,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.41,
    y: 110.02,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 56.41,
    y: 111.3,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 56.41,
    y: 112.59,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 56.41,
    y: 113.87,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 56.41,
    y: 115.16,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 56.41,
    y: 116.44,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 56.41,
    y: 117.73,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 56.41,
    y: 119.01,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 56.41,
    y: 120.29,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 56.41,
    y: 121.58,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 56.41,
    y: 122.86,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 56.41,
    y: 124.15,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 56.41,
    y: 125.43,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 56.41,
    y: 126.71,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 56.41,
    y: 128,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 56.41,
    y: 129.28,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 56.41,
    y: 130.57,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 56.41,
    y: 131.85,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 56.41,
    y: 133.14,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 56.41,
    y: 134.42,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 56.41,
    y: 135.7,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 56.41,
    y: 136.99,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 56.41,
    y: 138.27,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 56.41,
    y: 139.56,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 56.41,
    y: 140.84,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 56.41,
    y: 142.12,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 56.41,
    y: 143.41,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 56.41,
    y: 144.69,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 56.41,
    y: 145.98,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 56.41,
    y: 147.26,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 56.41,
    y: 148.55,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 56.41,
    y: 149.83,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 56.41,
    y: 151.11,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 56.41,
    y: 152.4,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 56.41,
    y: 153.68,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.41,
    y: 154.97,
    width: 262.71,
    height: 1.28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.15,
    y: 144.11,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 60.15,
    y: 142.92,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 60.15,
    y: 141.73,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 60.15,
    y: 140.55,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 60.15,
    y: 139.36,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 60.15,
    y: 138.18,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 60.15,
    y: 136.99,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 60.15,
    y: 135.8,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 60.15,
    y: 134.62,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 60.15,
    y: 133.43,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 60.15,
    y: 132.24,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 60.15,
    y: 131.06,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 60.15,
    y: 129.87,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 60.15,
    y: 128.68,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 60.15,
    y: 127.5,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 60.15,
    y: 126.31,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 60.15,
    y: 125.13,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 60.15,
    y: 123.94,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 60.15,
    y: 122.75,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 60.15,
    y: 121.57,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 60.15,
    y: 120.38,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 60.15,
    y: 119.19,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 60.15,
    y: 118.01,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 60.15,
    y: 116.82,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 60.15,
    y: 115.63,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 60.15,
    y: 114.45,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 60.15,
    y: 113.26,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 60.15,
    y: 112.08,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 60.15,
    y: 110.89,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 60.15,
    y: 109.7,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 60.15,
    y: 108.52,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 60.15,
    y: 107.33,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 60.15,
    y: 106.14,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 60.15,
    y: 104.96,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 60.15,
    y: 103.77,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 60.15,
    y: 102.59,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 60.15,
    y: 101.4,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 60.15,
    y: 100.21,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 60.15,
    y: 99.03,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 60.15,
    y: 97.84,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 60.15,
    y: 96.65,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 60.15,
    y: 95.47,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 60.15,
    y: 94.28,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 60.15,
    y: 93.09,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 60.15,
    y: 91.91,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 60.15,
    y: 90.72,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 60.15,
    y: 89.54,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 60.15,
    y: 88.35,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 60.15,
    y: 87.16,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 60.15,
    y: 85.98,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 60.15,
    y: 84.79,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 60.15,
    y: 83.6,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 60.15,
    y: 82.42,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 60.15,
    y: 81.23,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 60.15,
    y: 80.04,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 60.15,
    y: 78.86,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 60.15,
    y: 77.67,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 60.15,
    y: 76.49,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 60.15,
    y: 75.3,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 60.15,
    y: 74.11,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 60.15,
    y: 72.93,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 60.15,
    y: 71.74,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 60.15,
    y: 70.55,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 60.15,
    y: 69.37,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 60.15,
    y: 68.18,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 60.15,
    y: 67,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 60.15,
    y: 65.81,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 60.15,
    y: 64.62,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 60.15,
    y: 63.44,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 60.15,
    y: 62.25,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 60.15,
    y: 61.06,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 60.15,
    y: 59.88,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 60.15,
    y: 58.69,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 60.15,
    y: 57.5,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 60.15,
    y: 56.32,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 60.15,
    y: 55.13,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.15,
    y: 53.95,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 60.15,
    y: 52.76,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 60.15,
    y: 51.57,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 60.15,
    y: 50.39,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 60.15,
    y: 49.2,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 60.15,
    y: 48.01,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 60.15,
    y: 46.83,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 60.15,
    y: 45.64,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 60.15,
    y: 44.45,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 60.15,
    y: 43.27,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 60.15,
    y: 42.08,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 60.15,
    y: 40.9,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 60.15,
    y: 39.71,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 60.15,
    y: 38.52,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 60.15,
    y: 37.34,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 60.15,
    y: 36.15,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 60.15,
    y: 34.96,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 60.15,
    y: 33.78,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 60.15,
    y: 32.59,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 60.15,
    y: 31.41,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 60.15,
    y: 30.22,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 60.15,
    y: 29.03,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 60.15,
    y: 27.85,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 60.15,
    y: 26.66,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 60.15,
    y: 25.47,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 60.15,
    y: 24.29,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.15,
    y: 23.1,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 60.15,
    y: 21.91,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 60.15,
    y: 20.73,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 60.15,
    y: 19.54,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 60.15,
    y: 18.36,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 60.15,
    y: 17.17,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 60.15,
    y: 15.98,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 60.15,
    y: 14.8,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 60.15,
    y: 13.61,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.15,
    y: 12.42,
    width: 255.65,
    height: 1.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 132.41,
    cy: 48.18,
    r: 45.29,
    transform: "translate(37.23 152.07) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 243.13,
    cy: 48.18,
    r: 45.29,
    transform: "translate(149.84 277.81) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 90.01,
    y: 89.58,
    width: 84.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 90.01,
    y: 88.45,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 90.01,
    y: 87.32,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 90.01,
    y: 86.19,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 90.01,
    y: 85.06,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 90.01,
    y: 83.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 90.01,
    y: 82.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 90.01,
    y: 81.66,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 90.01,
    y: 80.53,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 90.01,
    y: 79.4,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 90.01,
    y: 78.27,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 90.01,
    y: 77.14,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 90.01,
    y: 76.01,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 90.01,
    y: 74.88,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 90.01,
    y: 73.75,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.01,
    y: 72.62,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 90.01,
    y: 71.49,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 90.01,
    y: 70.36,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 90.01,
    y: 69.23,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 90.01,
    y: 68.1,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 90.01,
    y: 66.97,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 90.01,
    y: 65.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 90.01,
    y: 64.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 90.01,
    y: 63.57,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 90.01,
    y: 62.44,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 90.01,
    y: 61.31,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 90.01,
    y: 60.18,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 90.01,
    y: 59.05,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 90.01,
    y: 57.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 90.01,
    y: 56.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 90.01,
    y: 55.66,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 90.01,
    y: 54.53,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 90.01,
    y: 53.4,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 90.01,
    y: 52.27,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 90.01,
    y: 51.14,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 90.01,
    y: 50.01,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 90.01,
    y: 48.88,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 90.01,
    y: 47.74,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 90.01,
    y: 46.61,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 90.01,
    y: 45.48,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 90.01,
    y: 44.35,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 90.01,
    y: 43.22,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 90.01,
    y: 42.09,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 90.01,
    y: 40.96,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 90.01,
    y: 39.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 90.01,
    y: 38.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.01,
    y: 37.57,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 90.01,
    y: 36.44,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 90.01,
    y: 35.31,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 90.01,
    y: 34.18,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 90.01,
    y: 33.05,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 90.01,
    y: 31.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 90.01,
    y: 30.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 90.01,
    y: 29.65,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 90.01,
    y: 28.52,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 90.01,
    y: 27.39,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 90.01,
    y: 26.26,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 90.01,
    y: 25.13,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 90.01,
    y: 24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 90.01,
    y: 22.87,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 90.01,
    y: 21.74,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 90.01,
    y: 20.61,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 90.01,
    y: 19.48,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 90.01,
    y: 18.35,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 90.01,
    y: 17.22,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 90.01,
    y: 16.09,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 90.01,
    y: 14.96,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 90.01,
    y: 13.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 90.01,
    y: 12.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 90.01,
    y: 11.56,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 90.01,
    y: 10.43,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 90.01,
    y: 9.3,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 90.01,
    y: 8.17,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 90.01,
    y: 7.04,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 90.01,
    y: 5.91,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 90.01,
    y: 5.78,
    width: 84.8,
    height: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 84.23,
    y: 95.23,
    width: 96.35,
    height: 1.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 84.23,
    y: 94.1,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 84.23,
    y: 92.97,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 84.23,
    y: 91.84,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 84.23,
    y: 90.71,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 84.23,
    y: 89.58,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 84.23,
    y: 88.45,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 84.23,
    y: 87.32,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 84.23,
    y: 86.19,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 84.23,
    y: 85.06,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 84.23,
    y: 83.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 84.23,
    y: 82.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 84.23,
    y: 81.66,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 84.23,
    y: 80.53,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 84.23,
    y: 79.4,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 84.23,
    y: 78.27,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 84.23,
    y: 77.14,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 84.23,
    y: 76.01,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 84.23,
    y: 74.88,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 84.23,
    y: 73.75,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 84.23,
    y: 72.62,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 84.23,
    y: 71.49,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 84.23,
    y: 70.36,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 84.23,
    y: 69.23,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 84.23,
    y: 68.1,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 84.23,
    y: 66.97,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 84.23,
    y: 65.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 84.23,
    y: 64.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 84.23,
    y: 63.57,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 84.23,
    y: 62.44,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 84.23,
    y: 61.31,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 84.23,
    y: 60.18,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 84.23,
    y: 59.05,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 84.23,
    y: 57.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 84.23,
    y: 56.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 84.23,
    y: 55.66,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 84.23,
    y: 54.53,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 84.23,
    y: 53.4,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 84.23,
    y: 52.27,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 84.23,
    y: 51.14,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 84.23,
    y: 50.01,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 84.23,
    y: 48.88,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 84.23,
    y: 47.74,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 84.23,
    y: 46.61,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 84.23,
    y: 45.48,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 84.23,
    y: 44.35,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 84.23,
    y: 43.22,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 84.23,
    y: 42.09,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 84.23,
    y: 40.96,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 84.23,
    y: 39.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 84.23,
    y: 38.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.23,
    y: 37.57,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 84.23,
    y: 36.44,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 84.23,
    y: 35.31,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 84.23,
    y: 34.18,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 84.23,
    y: 33.05,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 84.23,
    y: 31.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 84.23,
    y: 30.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 84.23,
    y: 29.65,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 84.23,
    y: 28.52,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 84.23,
    y: 27.39,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 84.23,
    y: 26.26,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 84.23,
    y: 25.13,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 84.23,
    y: 24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 84.23,
    y: 22.87,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 84.23,
    y: 21.74,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 84.23,
    y: 20.61,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 84.23,
    y: 19.48,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 84.23,
    y: 18.35,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 84.23,
    y: 17.22,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 84.23,
    y: 16.09,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 84.23,
    y: 14.96,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 84.23,
    y: 13.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 84.23,
    y: 12.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 84.23,
    y: 11.56,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 84.23,
    y: 10.43,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 84.23,
    y: 9.3,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 84.23,
    y: 8.17,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 84.23,
    y: 7.04,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 84.23,
    y: 5.91,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 84.23,
    y: 4.78,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 84.23,
    y: 3.65,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 84.23,
    y: 0,
    width: 96.35,
    height: 3.65
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 200.73,
    y: 89.58,
    width: 84.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 200.73,
    y: 88.45,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 200.73,
    y: 87.32,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 200.73,
    y: 86.19,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 200.73,
    y: 85.06,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 200.73,
    y: 83.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 200.73,
    y: 82.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 200.73,
    y: 81.66,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 200.73,
    y: 80.53,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 200.73,
    y: 79.4,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 200.73,
    y: 78.27,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 200.73,
    y: 77.14,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 200.73,
    y: 76.01,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 200.73,
    y: 74.88,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 200.73,
    y: 73.75,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 200.73,
    y: 72.62,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 200.73,
    y: 71.49,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 200.73,
    y: 70.36,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 200.73,
    y: 69.23,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 200.73,
    y: 68.1,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 200.73,
    y: 66.97,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 200.73,
    y: 65.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 200.73,
    y: 64.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 200.73,
    y: 63.57,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 200.73,
    y: 62.44,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 200.73,
    y: 61.31,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 200.73,
    y: 60.18,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 200.73,
    y: 59.05,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 200.73,
    y: 57.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 200.73,
    y: 56.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 200.73,
    y: 55.66,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 200.73,
    y: 54.53,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 200.73,
    y: 53.4,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 200.73,
    y: 52.27,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 200.73,
    y: 51.14,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 200.73,
    y: 50.01,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 200.73,
    y: 48.88,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 200.73,
    y: 47.74,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 200.73,
    y: 46.61,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 200.73,
    y: 45.48,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 200.73,
    y: 44.35,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 200.73,
    y: 43.22,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 200.73,
    y: 42.09,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 200.73,
    y: 40.96,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 200.73,
    y: 39.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 200.73,
    y: 38.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 200.73,
    y: 37.57,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 200.73,
    y: 36.44,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 200.73,
    y: 35.31,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 200.73,
    y: 34.18,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 200.73,
    y: 33.05,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 200.73,
    y: 31.92,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 200.73,
    y: 30.79,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 200.73,
    y: 29.65,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 200.73,
    y: 28.52,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 200.73,
    y: 27.39,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 200.73,
    y: 26.26,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 200.73,
    y: 25.13,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 200.73,
    y: 24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 200.73,
    y: 22.87,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 200.73,
    y: 21.74,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 200.73,
    y: 20.61,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 200.73,
    y: 19.48,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 200.73,
    y: 18.35,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 200.73,
    y: 17.22,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 200.73,
    y: 16.09,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 200.73,
    y: 14.96,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 200.73,
    y: 13.83,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 200.73,
    y: 12.7,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 200.73,
    y: 11.56,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 200.73,
    y: 10.43,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 200.73,
    y: 9.3,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 200.73,
    y: 8.17,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 200.73,
    y: 7.04,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 200.73,
    y: 5.91,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 200.73,
    y: 5.78,
    width: 84.8,
    height: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 194.95,
    y: 95.23,
    width: 96.35,
    height: 1.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 194.95,
    y: 94.1,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 194.95,
    y: 92.97,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 194.95,
    y: 91.84,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 194.95,
    y: 90.71,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 194.95,
    y: 89.58,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 194.95,
    y: 88.45,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 194.95,
    y: 87.32,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 194.95,
    y: 86.19,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 194.95,
    y: 85.06,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 194.95,
    y: 83.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 194.95,
    y: 82.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 194.95,
    y: 81.66,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 194.95,
    y: 80.53,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 194.95,
    y: 79.4,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 194.95,
    y: 78.27,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 194.95,
    y: 77.14,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 194.95,
    y: 76.01,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 194.95,
    y: 74.88,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 194.95,
    y: 73.75,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 194.95,
    y: 72.62,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 194.95,
    y: 71.49,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 194.95,
    y: 70.36,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 194.95,
    y: 69.23,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 194.95,
    y: 68.1,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 194.95,
    y: 66.97,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 194.95,
    y: 65.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 194.95,
    y: 64.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 194.95,
    y: 63.57,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 194.95,
    y: 62.44,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 194.95,
    y: 61.31,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 194.95,
    y: 60.18,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 194.95,
    y: 59.05,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 194.95,
    y: 57.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 194.95,
    y: 56.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 194.95,
    y: 55.66,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 194.95,
    y: 54.53,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 194.95,
    y: 53.4,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 194.95,
    y: 52.27,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 194.95,
    y: 51.14,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 194.95,
    y: 50.01,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 194.95,
    y: 48.88,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 194.95,
    y: 47.74,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 194.95,
    y: 46.61,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 194.95,
    y: 45.48,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 194.95,
    y: 44.35,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 194.95,
    y: 43.22,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 194.95,
    y: 42.09,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 194.95,
    y: 40.96,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 194.95,
    y: 39.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 194.95,
    y: 38.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 194.95,
    y: 37.57,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 194.95,
    y: 36.44,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 194.95,
    y: 35.31,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 194.95,
    y: 34.18,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 194.95,
    y: 33.05,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 194.95,
    y: 31.92,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 194.95,
    y: 30.79,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 194.95,
    y: 29.65,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 194.95,
    y: 28.52,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 194.95,
    y: 27.39,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 194.95,
    y: 26.26,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 194.95,
    y: 25.13,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 194.95,
    y: 24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 194.95,
    y: 22.87,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 194.95,
    y: 21.74,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 194.95,
    y: 20.61,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 194.95,
    y: 19.48,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 194.95,
    y: 18.35,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 194.95,
    y: 17.22,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 194.95,
    y: 16.09,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 194.95,
    y: 14.96,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 194.95,
    y: 13.83,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 194.95,
    y: 12.7,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 194.95,
    y: 11.56,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 194.95,
    y: 10.43,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 194.95,
    y: 9.3,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 194.95,
    y: 8.17,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 194.95,
    y: 7.04,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 194.95,
    y: 5.91,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 194.95,
    y: 4.78,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 194.95,
    y: 3.65,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 194.95,
    y: 0,
    width: 96.35,
    height: 3.65
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M150.9,40.43h-10.75v-10.75c0-4.28-3.47-7.75-7.75-7.75s-7.75,3.47-7.75,7.75v10.75h-10.75c-4.28,0-7.75,3.47-7.75,7.75s3.47,7.75,7.75,7.75h10.75v10.75c0,4.28,3.47,7.75,7.75,7.75s7.75-3.47,7.75-7.75v-10.75h10.75c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 243.13,
    cy: 28.98,
    r: 9.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 243.13,
    cy: 67.38,
    r: 9.07,
    transform: "translate(23.57 191.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 262.33,
    cy: 48.18,
    r: 9.07,
    transform: "translate(172.75 299.4) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 223.93,
    cy: 48.18,
    r: 9.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 172.86,
    y: 34.18,
    width: 29.46,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 172.86,
    y: 33.05,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 172.86,
    y: 31.92,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 172.86,
    y: 30.78,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 172.86,
    y: 29.65,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 172.86,
    y: 28.52,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 172.86,
    y: 27.39,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 172.86,
    y: 26.26,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 172.86,
    y: 25.13,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 172.86,
    y: 24,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 172.86,
    y: 22.87,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 172.86,
    y: 21.74,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 172.86,
    y: 20.61,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 172.86,
    y: 19.62,
    width: 29.46,
    height: 0.99
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 288.42,
    y: 44.35,
    width: 9.96,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 288.42,
    y: 43.22,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 288.42,
    y: 42.09,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 288.42,
    y: 40.96,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 288.42,
    y: 39.83,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 288.42,
    y: 39.47,
    width: 9.96,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 77.16,
    y: 44.35,
    width: 9.96,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 77.16,
    y: 43.22,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 77.16,
    y: 42.09,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 77.16,
    y: 40.96,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 77.16,
    y: 39.83,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 77.16,
    y: 39.47,
    width: 9.96,
    height: 0.36
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 154.71,
    y: 144.37,
    width: 62.63,
    height: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 154.71,
    y: 144.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 154.71,
    y: 143.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 154.71,
    y: 143.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 154.71,
    y: 143.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 154.71,
    y: 142.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 154.71,
    y: 142.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 154.71,
    y: 142.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 154.71,
    y: 141.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 154.71,
    y: 141.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 154.71,
    y: 141.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 154.71,
    y: 140.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 154.71,
    y: 140.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 154.71,
    y: 140.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 154.71,
    y: 139.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 154.71,
    y: 139.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 154.71,
    y: 139.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 154.71,
    y: 138.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 154.71,
    y: 138.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 154.71,
    y: 138.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 154.71,
    y: 137.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 154.71,
    y: 137.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 154.71,
    y: 137.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 154.71,
    y: 136.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 154.71,
    y: 136.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 154.71,
    y: 136.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 154.71,
    y: 135.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.71,
    y: 135.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 154.71,
    y: 135.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 154.71,
    y: 134.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 154.71,
    y: 134.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 154.71,
    y: 134.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 154.71,
    y: 133.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 154.71,
    y: 133.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 154.71,
    y: 133.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 154.71,
    y: 132.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 154.71,
    y: 132.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 154.71,
    y: 132.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 154.71,
    y: 131.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 154.71,
    y: 131.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 154.71,
    y: 131.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 154.71,
    y: 130.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 154.71,
    y: 130.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 154.71,
    y: 130.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 154.71,
    y: 129.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 154.71,
    y: 129.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 154.71,
    y: 129.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 154.71,
    y: 128.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 154.71,
    y: 128.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 154.71,
    y: 128.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 154.71,
    y: 127.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 154.71,
    y: 127.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 154.71,
    y: 127.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 154.71,
    y: 126.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 154.71,
    y: 126.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 154.71,
    y: 126.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 154.71,
    y: 125.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 154.71,
    y: 125.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.71,
    y: 125.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 154.71,
    y: 124.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 154.71,
    y: 124.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 154.71,
    y: 124.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 154.71,
    y: 123.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 154.71,
    y: 123.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 154.71,
    y: 123.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 154.71,
    y: 122.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 154.71,
    y: 122.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 154.71,
    y: 122.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 154.71,
    y: 121.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 154.71,
    y: 121.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 154.71,
    y: 121.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 154.71,
    y: 120.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 154.71,
    y: 120.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 154.71,
    y: 120.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 154.71,
    y: 119.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 154.71,
    y: 119.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 154.71,
    y: 119.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 154.71,
    y: 118.68,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 154.71,
    y: 118.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 154.71,
    y: 118.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 154.71,
    y: 117.68,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 154.71,
    y: 117.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 154.71,
    y: 117.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 154.71,
    y: 116.68,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 154.71,
    y: 116.35,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 154.71,
    y: 116.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 154.71,
    y: 115.89,
    width: 62.63,
    height: 0.12
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.88299f3d92c01a9d60e02d92c2ab3221.svg";
export { ForwardRef as ReactComponent };